export const addItemsToCart = async (items) => {
  try {
    const { default: axios } = await import("axios");
    const { data } = await axios.post("/cart/add.js", { items });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const updateItems = async (items) => {
  try {
    const { default: axios } = await import("axios");

    await axios.post("/cart/update.js", {
      updates: {
        ...items,
      },
    });

    const { data } = await axios.post("/cart/change.js", {
      id: Object.keys(items)[0],
      quantity: Object.values(items)[0],
      properties: { _created_at: Date.now() },
    });

    return data;
  } catch (error) {
    console.log(error);
  }
};
